<template>
  <div>
    <area-chart
      :info-card="computedInfoCards"
      :data-series="computedSeries"
      :time-stamps="timeStamps"
      :format-percentage="true"
    />
  </div>
</template>

<script>
import AreaChart from '../widgets/AreaChart.vue'

export default {
  components: { AreaChart },
  data() {
    return {}
  },
  computed: {
    usedSpaceStats() {
      return this.$store.state.storageAnalytics.usedSpaceStats.stats ?? []
    },
    loadingUsedSpaceStats() {
      return this.$store.state.storageAnalytics.loadingUsedSpaceStats
    },
    peakComputed() {
      const data = this.computedSeries.map(x => x.data)[0]
      const peak = data.length !== 0 ? Math.max(...data) : 0
      const peakIndex = data.indexOf(peak)

      return {
        peak,
        peakTime: (this.computedSeries.map(x => x.timestamps)[0])[peakIndex],
      }
    },
    usedSpace() {
      const data = this.computedSeries.map(x => x.data)[0]

      return data[data.length - 1]
    },
    computedInfoCards() {
      const infoCard = [
        {
          id: 1,
          title: 'Peak',
          description: this.formatBytes(this.peakComputed.peak),
          loading: this.loadingUsedSpaceStats,
        },
        {
          id: 2,
          title: 'Peak Time',
          description: this.unixTimestampToDateTime(this.peakComputed.peakTime),
          loading: this.loadingUsedSpaceStats,
        },
        {
          id: 3,
          title: 'Used Space',
          description: this.formatBytes(this.usedSpace),
          loading: this.loadingUsedSpaceStats,
        },
      ]
      return infoCard
    },
    computedDateTime() {
      return this.formateDateTime('2023-09-15T08:50:30.625812Z')
    },
    computedSeries() {
      return this.getFormattedSeries(this.usedSpaceStats)
    },
    timeStamps() {
      if (this.usedSpaceStats && this.usedSpaceStats.length > 0) {
        return this.usedSpaceStats.map(x => x.timestamp)
      }

      return null
    },
  },
  methods: {
    getFormattedSeries(dataList) {
      const series = [{
        name: 'Used Space',
        data: dataList?.map(item => item.value) || [],
        timestamps: dataList?.map(item => item.timestamp) || [],
      }]

      return series
    },
  },
}
</script>
